import { LINK_FIELD } from '../elements/link'
import { HOVER_IMAGE } from '../elements/assets'

export const FEATURE_LIST = `
...on featureList_Entry {
  id
  typeHandle
  anchorId

  heading: headingAdvanced {
    html
  }
  description

  featureList {
    id

    ${ HOVER_IMAGE }

    title
    description

    ${ LINK_FIELD }
  }
}
`